import { dateService, FORMATS } from '@/global/services/date'
import { isEmpty, isObject } from '@/global/utils/utils'

const TAB_KEY = 'basicInfo'
export default {
  name: 'basicInfo',

  computed: {
    basicInfoEditConfig () {
      return {
        title: this.$t('base/profile.basic_info'),
        key: TAB_KEY,
        apiConfig: {
          get: {
            module: 'administration',
            route: `expenses/${this.$route.params.id}`,
            method: 'get'
          },
          post: {
            module: 'administration',
            route: `expenses/${this.$route.params.id}`,
            method: 'post'
          }
        },
        dataFetched: (event) => this.onDataFetched(event),
        afterCancel: (event) => this.onDataFetched(event),
        afterSave: (event) => this.onDataFetched(event),
        modifyDataBeforeSend: (event) => this.onModifyDataBeforeSend(event),
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.$t('administration/expense.edit_expense_details'),
            showBackButton: {
              onGoBack: () => {
                this.$router.replace({ name: 'Expenses' }).then()
              }
            }
          },
          {
            component: this.columnsContentComponent,
            showButtons: false,
            rows: [
              {
                type: 'fields',
                columnsCount: 4,
                fields: [
                  {
                    key: 'date',
                    label: this.$t('administration/expense.date'),
                    type: 'datetime-picker',
                    appendIcon: 'mdi-calendar-month',
                    format: FORMATS.datetimeShort,
                    placeholder: FORMATS.datetimeShort,
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'type_id',
                    label: this.$t('administration/expense_type.type'),
                    placeholder: this.$t('administration/expense.choose_expense_type'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'administration',
                      route: 'expense-types/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'vehicle_id',
                    label: this.$t('administration/expense.vehicle'),
                    placeholder: this.$t('administration/expense.choose_vehicle'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'vehicles/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'person_id',
                    label: this.$t('people/person.driver'),
                    placeholder: this.$t('administration/expense.choose_driver'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'people',
                      route: 'people/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'partner_id',
                    label: 'Partner',
                    placeholder: this.$t('administration/expense.choose_partner'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'administration',
                      route: 'partners/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'item',
                    label: this.$t('administration/expense.item'),
                    placeholder: this.$t('administration/expense.enter_article'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'quantity',
                    label: this.$t('administration/expense.quantity'),
                    field_type: 'number',
                    placeholder: this.$t('administration/expense.enter_quantity'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'bill_number',
                    label: this.$t('administration/expense.bill_number'),
                    placeholder: this.$t('administration/expense.enter_bill_number'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'net_amount',
                    label: this.$t('administration/expense.net_amount'),
                    placeholder: this.$t('administration/expense.enter_net_amount'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'gross_amount',
                    label: this.$t('administration/expense.gross_amount'),
                    placeholder: this.$t('administration/expense.enter_gross_amount'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'currency_id',
                    label: this.$t('administration.currency'),
                    placeholder: this.$t('administration/expense.choose_currency'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'administration',
                      route: 'currencies/autocomplete'
                    },
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    async onDataFetched (event) {
      const { data: apiData, updateData, formDataForSend } = event || {}

      const data = apiData?.data || formDataForSend || {}
      if (data && !isEmpty(data) && isObject(data) && typeof updateData === 'function') {
        updateData({
          date: data?.date ? dateService.formatCustom(data.date, FORMATS.isoDatetime, FORMATS.datetimeShort) : null,
          type_id: data?.type?.id || null,
          vehicle_id: data?.vehicle?.id || null,
          person_id: data?.person?.id || null,
          partner_id: data?.partner?.id || null,
          currency_id: data?.currency?.id || null
        })
      }
    },

    onModifyDataBeforeSend (event) {
      const { copiedData } = event || {}
      if (copiedData) {
        copiedData.date = copiedData?.date ? dateService.formatCustom(copiedData.date, FORMATS.datetimeShort, FORMATS.isoDatetime) : null
        copiedData.net_amount = copiedData?.net_amount ? copiedData.net_amount.replace(',', '.') : null
        copiedData.gross_amount = copiedData?.gross_amount ? copiedData.gross_amount.replace(',', '.') : null
        copiedData.quantity = copiedData?.quantity ? copiedData.quantity.replace(',', '.') : null
      }
      return copiedData
    }
  }
}
